import { Loader, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { IFiasAdress } from '../../Services/ResponseData';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import SelectWithChoice from './SelectWithChoice';

export interface IFIASValue {
    [level: number]: IFiasAdress
}

export interface IProps {
    value?: IFIASValue
    onValueChange: (value: IFIASValue) => void
    rerenderKey: string
    label: string
    initAdress?: string
}

interface IState {
    loadedAdresses: IFiasAdress[];
    loadedOptions: { key: string, value: string }[]
    options: { key: string, value: string }[]
    optionsLoad: boolean
    currentInput: string;
}

export default class FIASField extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    private innerInputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.innerInputRef = React.createRef();
        this.state = {
            loadedAdresses: [],
            options: [],
            loadedOptions: [],
            currentInput: this.props.initAdress || '',
            optionsLoad: false
        }
    }

    componentDidMount(): void {
        this.GetOptions(0, -1, undefined);
    }


    private async GetOptions(level: number, parentLevel: number, parentGuid?: string | undefined): Promise<void> {
        this.setState({ options: [], optionsLoad: true });
        let loadedAdresses = await new WebService(this.context.token).GetFiasAdressList(level, parentLevel, parentGuid);
        let options = loadedAdresses.map(a => (this.mapPartToString(a)))
        this.setState({
            loadedAdresses: loadedAdresses,
            options: options,
            loadedOptions: options,
            optionsLoad: false
        });

    }

    private filterOptions(filter: string): { key: string, value: string }[] {
        if (!!filter) {
            return this.state.loadedOptions.filter(o => o.value.toLowerCase().indexOf(filter.toLowerCase()) > -1);

        }
        else return [];
    }

    private mapPartToString(part: IFiasAdress): { value: string, key: string } {
        if (part.level < 6)
            return { value: `${part.value} ${part.artShort}`, key: part.id };
        else if (part.level == 6) {
            let resultArray: string[] = [];
            if (!!part.houseNum)
                resultArray.push(`д. ${part.houseNum}`)
            if (!!part.houseStruc)
                resultArray.push(`корп. ${part.houseStruc}`)
            if (!!part.houseCorp)
                resultArray.push(`стр. ${part.houseCorp}`)
            if (!!part.houseBuild)
                resultArray.push(`стр. ${part.houseBuild}`)
            return ({ value: resultArray.join(' '), key: part.id });
        }
        else {
            return { value: part.value, key: part.id };
        }
    }

    private getFIASParts(value: IFIASValue | undefined): string[] {
        if (!!value) {
            let resultArray: string[] = [];
            for (let level in value) {
                const part = value[level];
                if (!!part)
                    resultArray.push(this.mapPartToString(part).value);
            }
            return resultArray;
        }
        else
            return [];
    }

    private getMaxLevel(value: IFIASValue) {
        const levels: number[] = Object.keys(value).filter(val => !!val).map(val => parseInt(val));
        return levels.length > 0 ? Math.max(...levels) : -1;
    }

    private addToAdress(value: string, level: number): IFIASValue {
        let currentValue: IFIASValue = !!this.props.value ? { ...this.props.value } : {};
        const item = this.state.loadedAdresses.find(o => o.id == value);
        if (!!item)
            currentValue[level] = item;
        return currentValue;
    }

    private deleteLastFromAdress(deleteCount: number): IFIASValue {
        let currentValue = !!this.props.value ? { ...this.props.value } : {};
        let level = this.getMaxLevel(currentValue);
        while (deleteCount > 0) {
            if (!!currentValue[level]) {
                delete currentValue[level];
                level--;
                deleteCount--;
            }
        }
        return currentValue;
    }

    private onInputChange(value: string) {
        const currentVal = this.getFIASParts(this.props.value).join(', ');
        if (!currentVal && this.state.currentInput.indexOf(value) > -1)
            this.setState({ currentInput: '' });
        else {
            let isDeleteVal = !value || this.state.currentInput.indexOf(value) > -1;
            if (isDeleteVal) {
                const newValLength = value?.split(',').length;
                const oldLength = currentVal.split(',').length;
                const newVal = this.deleteLastFromAdress(oldLength - newValLength);
                this.props.onValueChange(newVal);
                const newLevel = this.getMaxLevel(newVal);
                this.GetOptions(-1, newLevel, newVal[newLevel]?.id).then(_ => { !!this.innerInputRef.current && this.innerInputRef.current.focus(); });
                this.setState({ currentInput: value });
            }
            else {
                const filterVal = value.replace(currentVal, '').replace(',', '').trim();
                var options = this.filterOptions(filterVal);
                if (options.length == 1)
                    this.onSelectOption(options[0].key)
                else if (options.length > 0)
                    this.setState({ options, currentInput: value });
            }

        }
    }


    private onSelectOption(id: string) {
        const item = this.state.loadedAdresses.find(o => o.id == id);
        if (!!item) {
            if (item.level > -1) {
                let newValue = this.addToAdress(id, item.level);
                this.props.onValueChange(newValue);
                this.GetOptions(-1, item.level, id).then(_ => { !!this.innerInputRef.current && this.innerInputRef.current.focus(); });
                this.setState({ currentInput: this.getFIASParts(newValue).join(', ') + ' ' })
            }
        }
    }

    render(): React.ReactNode {
        return <div className='fias_wraper'>
            <Typography variant='body14' weight='semiBold'>{this.props.label}</Typography>
            <Typography variant='body14' >Начните вводить адрес и выберите варианты из выпадающего списка</Typography>
            <Typography variant='body14' className='maskHelp'>Например: <i>Московская обл, Дзержинский г, Лесная ул, д. 21, 163</i></Typography>
            <SelectWithChoice
                options={this.state.options}
                onInputChange={(value) => this.onInputChange(value)}
                currentInput={this.state.optionsLoad ? "Загрузка..." : this.state.currentInput}
                onSelectOption={(key) => { this.onSelectOption(key) }}
                disabled={this.state.optionsLoad}
                innerInputRef={this.innerInputRef}
            />
        </div>
    }
}




